<template>
  <Search />
</template>

<script>
import Search from '@/components/Search';
export default {
  components: {
    Search
  },
  nuxtI18n: {
    paths: {
      en: '/free-vectors/:search',
      es: '/vectores-gratis/:search',
      pt: '/vetores-gratis/:search'
    }
  }
};
</script>

<style></style>
